import { useMemo, useState } from "react";
import { relatedTags, searchSuggestions } from "@/mocks/home";

export default function RelatedSearch() {
  const [query, setQuery] = useState("");

  const trimmed = query.trim();
  const results = useMemo(() => {
    if (!trimmed) return searchSuggestions;
    const key = trimmed.toLowerCase();
    return searchSuggestions.filter(
      (item) => item.keyword.toLowerCase().includes(key) || item.desc.toLowerCase().includes(key)
    );
  }, [trimmed]);

  return (
    <section id="tags" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="text-xs md:text-sm font-semibold tracking-widest text-secondary-700 uppercase">
            Related Search
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            相关搜索与标签
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            把「善良的女秘书」与渠道词组合，能更快定位到想要的检索方向。点击下面的标签或直接输入关键词，
            即可在本页已有的检索方向中筛选，结果仅作用于当前页面内容。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_360px] gap-6">
          <div>
            <div className="flex flex-wrap gap-2">
              {relatedTags.map((tag) => {
                const isActive = trimmed === tag;
                return (
                  <button
                    key={tag}
                    type="button"
                    onClick={() => setQuery(isActive ? "" : tag)}
                    className={`px-3 py-1.5 rounded-full text-xs md:text-sm border transition-colors cursor-pointer ${
                      isActive
                        ? "bg-primary-500 border-primary-500 text-background-50"
                        : "bg-background-100 border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
                    }`}
                  >
                    {tag}
                  </button>
                );
              })}
            </div>

            <div className="mt-5 flex items-center justify-between">
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                检索方向
                <span className="ml-2 text-xs font-normal text-foreground-500">共 {results.length} 条</span>
              </h3>
            </div>

            {results.length > 0 ? (
              <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
                {results.map((item) => (
                  <article key={item.keyword} className="rounded-lg border border-background-200 bg-background-100 p-4">
                    <div className="flex items-start justify-between gap-3">
                      <h4 className="font-heading text-sm font-bold text-foreground-950">{item.keyword}</h4>
                      <span className="shrink-0 px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px] font-medium whitespace-nowrap">
                        {item.channel}
                      </span>
                    </div>
                    <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  </article>
                ))}
              </div>
            ) : (
              <div className="mt-4 rounded-lg border border-dashed border-background-300 bg-background-100 p-8 text-center">
                <i className="ri-search-eye-line text-3xl text-foreground-400"></i>
                <p className="mt-3 text-sm text-foreground-600">
                  没有匹配「{trimmed}」的检索方向，试试更短的关键词或直接点击上方标签。
                </p>
              </div>
            )}
          </div>

          <aside className="lg:sticky lg:top-32 h-fit rounded-lg border border-background-200 bg-background-100 p-5">
            <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-filter-3-line text-primary-600"></i>
              筛选取向
            </h3>
            <label htmlFor="related-search-input" className="mt-4 block text-xs font-medium text-foreground-600">
              输入关键词筛选
            </label>
            <div className="mt-2 relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
              <input
                id="related-search-input"
                type="text"
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                placeholder="如：磁力、网盘、阿里云盘"
                className="w-full pl-9 pr-9 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
              />
              {trimmed && (
                <button
                  type="button"
                  aria-label="清空关键词"
                  onClick={() => setQuery("")}
                  className="absolute right-2.5 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center rounded-full text-foreground-500 hover:text-primary-600 cursor-pointer"
                >
                  <i className="ri-close-line"></i>
                </button>
              )}
            </div>
            <p className="mt-3 text-xs leading-relaxed text-foreground-500">
              输入会实时过滤本页的检索方向条目，不会请求任何外部接口。
            </p>
          </aside>
        </div>
      </div>
    </section>
  );
}